import { render, staticRenderFns } from "./PartnerMaterData.vue?vue&type=template&id=2efb362b"
import script from "./PartnerMaterData.vue?vue&type=script&lang=js"
export * from "./PartnerMaterData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports